import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ListView, View } from 'react-native';
import styles from './scrollable-layout.styles';
import add from 'lodash/fp/add';
import every from 'lodash/fp/every';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import gte from 'lodash/fp/gte';
import identity from 'lodash/fp/identity';
import keys from 'lodash/fp/keys';
import lte from 'lodash/fp/lte';
import map from 'lodash/fp/map';
import min from 'lodash/fp/min';
import overEvery from 'lodash/fp/overEvery';
import property from 'lodash/fp/property';
import toInteger from 'lodash/fp/toInteger';
// import BackgroundPeek from '../background-peek';

const HEADER_COMPONENT_HEIGHT = 85;

// Detect whether an argument has the shape: [{ rows: [...] }, ...]
const bodyHasSections = overEvery([Array.isArray, every(flow(get('rows'), Array.isArray))]);

// Build a section with no header and one row
const sectionOf = x => [{ rows: [x] }];

class ScrollableLayout extends PureComponent {
  constructor() {
    super();
    this.state = { stickyId: -1 };
    this.renderSectionHeader = this.renderSectionHeader.bind(this);
    this.onChangeVisibleRows = this.onChangeVisibleRows.bind(this);
  }

  onChangeVisibleRows(visibleRows) {
    this.setState({ stickyId: flow(keys, map(toInteger), min)(visibleRows) });
  }

  mainStickyHeaderIsSticking() {
    return this.state.stickyId > 0;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.scrollOffset != null && this.props.scrollOffset !== newProps.scrollOffset) {
      this.shouldScroll = true;
    }
  }

  componentDidUpdate() {
    if (this.shouldScroll) {
      const internalOffset = HEADER_COMPONENT_HEIGHT + this.props.scrollOffset;
      this.handleScrollTo(internalOffset);
      this.shouldScroll = false;
    }
  }

  handleScrollTo(y) {
    this.listView.scrollTo({ y });
  }

  renderSectionHeader(header, sectionId) {
    // All section headers are backed by BackgroundPeek, which is made visible when the header
    // becomes sticky (or is the one above the sticky one)
    const showBackground = flow(
      toInteger,
      add(-this.state.stickyId),
      overEvery([lte(-1), gte(0)]),
    )(sectionId);

    // The main sticky header component should be inserted above section 1’s header, unless the
    // main sticky header is already sticking.
    const mainStickyHeader = sectionId === '1'
      && !this.mainStickyHeaderIsSticking()
      && this.props.stickyHeader;

    if (!(mainStickyHeader || header)) return null;

    return (
      <div testID="scrollable-layout-header-container">
        {/*  <BackgroundPeek visible={showBackground} /> */}
        { mainStickyHeader }
        { header && header }
      </div>
    );
  }

  render() {
    const { testID, header, body } = this.props;
    const bodySections = bodyHasSections(body) ? body : sectionOf(body);
    const sections = (header ? sectionOf(header) : []).concat(bodySections);

    const componentsDataSource = new ListView.DataSource({
      rowHasChanged: (r1, r2) => r1 !== r2,
      sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
      getSectionHeaderData: (data, sectionId) => get([sectionId, 'header'], sections),
    });

    return (      
   

      <div className="row"
       testID={testID}
       
      >
        <div className="columns small-12">

        { this.mainStickyHeaderIsSticking() && this.props.stickyHeader }
          <ListView
            scrollEnabled={this.props.scrollable}
            ref={ref => { this.listView = ref; }}
            dataSource={componentsDataSource.cloneWithRowsAndSections(sections.map(property('rows')))}
            renderRow={identity}
            renderSectionHeader={this.renderSectionHeader}
            onChangeVisibleRows={this.onChangeVisibleRows}
            className={'list-view'}
          />

        </div>

      </div>
      
  
    );
  }
}

ScrollableLayout.defaultProps = {
  scrollable: true,
};

const bodyComponentType = PropTypes.node;

const bodySectionsType = PropTypes.arrayOf(PropTypes.shape({
  header: PropTypes.node,
  rows: PropTypes.arrayOf(PropTypes.node).isRequired,
}));

ScrollableLayout.propTypes = {
  testID: PropTypes.string,
  header: PropTypes.node,
  stickyHeader: PropTypes.node,
  body: PropTypes.oneOfType([bodySectionsType, bodyComponentType]),
  scrollOffset: PropTypes.number,
  scrollable: PropTypes.bool,
};

export default ScrollableLayout;
